import { render, staticRenderFns } from "./PreviewAnchorTabs.vue?vue&type=template&id=11288012&scoped=true"
import script from "./PreviewAnchorTabs.vue?vue&type=script&lang=ts"
export * from "./PreviewAnchorTabs.vue?vue&type=script&lang=ts"
import style0 from "./PreviewAnchorTabs.vue?vue&type=style&index=0&id=11288012&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11288012",
  null
  
)

export default component.exports